var map = {
	"./lpg-masaze_1_after.jpg": 1047,
	"./lpg-masaze_1_before.jpg": 1048
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2176;



//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/ostatni nonrecursive \.(png|jpe?g|svg)$
// module id = 2176
// module chunks = 0